var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgEmptyorder = function SvgEmptyorder(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 123,
    viewBox: "0 0 131 123",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.791 51.9394C116.791 65.3737 111.244 77.4834 102.348 86.1873C93.6435 94.7966 81.5913 100 68.2957 100C55.0957 100 43.0435 94.702 34.2435 86.1873C25.3479 77.4834 19.8 65.3737 19.8 51.9394C19.8 25.3548 41.5131 3.87888 68.2957 3.87888C95.0783 3.87888 116.791 25.4494 116.791 51.9394Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.583 20.4352C114.749 20.4352 116.504 18.6985 116.504 16.5563C116.504 14.414 114.749 12.6774 112.583 12.6774C110.417 12.6774 108.661 14.414 108.661 16.5563C108.661 18.6985 110.417 20.4352 112.583 20.4352Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.322 5.29801C119.801 5.29801 121 4.11201 121 2.64901C121 1.186 119.801 0 118.322 0C116.843 0 115.644 1.186 115.644 2.64901C115.644 4.11201 116.843 5.29801 118.322 5.29801Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3304 20.3406C22.8095 20.3406 24.0086 19.1546 24.0086 17.6915C24.0086 16.2285 22.8095 15.0425 21.3304 15.0425C19.8512 15.0425 18.6521 16.2285 18.6521 17.6915C18.6521 19.1546 19.8512 20.3406 21.3304 20.3406Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97391 71.4286C7.72093 71.4286 9.94782 69.226 9.94782 66.509C9.94782 63.792 7.72093 61.5894 4.97391 61.5894C2.2269 61.5894 0 63.792 0 66.509C0 69.226 2.2269 71.4286 4.97391 71.4286Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_25566_42450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.369 29.6062C106.06 27.7958 104.097 27.9568 103.402 30.1695C101.848 35.0777 96.9819 36.8881 93.9967 37.3306C92.2793 24.7383 81.3201 15.0426 68.071 15.0426C54.8627 15.0426 43.9445 24.6981 42.1861 37.2099C39.1601 36.6467 34.7437 34.7961 33.2716 30.1292C32.5764 27.9165 30.6136 27.7958 29.305 29.566C26.647 33.1868 27.7511 37.8134 29.3868 41.5951C31.7995 47.3481 36.4612 51.4517 41.9408 54.2277C41.8181 61.0267 41.3274 66.5786 39.4054 73.7397C38.7512 76.1938 38.1787 78.2054 37.6471 79.533C37.279 80.4583 37.0337 81.3836 37.6062 82.3089C38.5876 83.8779 40.5095 84.3607 42.2679 84.6423C43.9036 84.924 45.2939 85.0446 46.4389 85.0849C49.2196 85.1653 50.4464 84.763 50.4464 84.763C50.4464 84.763 50.6508 85.0849 51.1824 85.5274C52.6954 86.855 56.9074 89.4298 66.3944 89.0677C78.2123 88.6252 82.7513 87.4987 84.8368 85.7286C85.0004 85.5676 85.164 85.447 85.2867 85.286C86.5952 85.286 87.7811 85.3263 88.8443 85.3263C92.5655 85.3665 95.2235 85.447 97.3499 84.6826C99.0265 84.0791 100.09 82.148 99.0265 80.0962C95.8369 73.9006 94.2012 67.0614 94.2012 60.1014V54.469C99.8852 51.6931 104.792 47.5493 107.287 41.5951C108.922 37.8134 110.027 33.1868 107.369 29.6062Z",
    fill: "url(#paint0_linear_25566_42450)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8848 85.2457C87.7807 85.2457 86.5949 85.2055 85.3272 85.2055C85.2045 85.3664 85.0409 85.5273 84.8774 85.648C83.6915 80.4582 82.6692 75.1477 82.4238 68.6303C84.1004 74.2224 86.2268 80.8203 88.8848 85.2457Z",
    fill: "#DFE0E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.182 85.4871C50.6504 85.0446 50.4459 84.7227 50.4459 84.7227C50.4459 84.7227 49.2192 85.1653 46.4385 85.0446C48.7693 80.8203 50.8549 72.8948 50.6095 67.9866C50.9775 76.6363 51.1002 82.0675 51.182 85.4871Z",
    fill: "#DFE0E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.379 44.3307C60.3213 44.3307 61.8958 42.7817 61.8958 40.8709C61.8958 38.96 60.3213 37.411 58.379 37.411C56.4368 37.411 54.8623 38.96 54.8623 40.8709C54.8623 42.7817 56.4368 44.3307 58.379 44.3307Z",
    fill: "#9CA4B5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9626 46.1412C78.9211 46.1412 81.3195 43.7816 81.3195 40.8709C81.3195 37.9602 78.9211 35.6006 75.9626 35.6006C73.0041 35.6006 70.6057 37.9602 70.6057 40.8709C70.6057 43.7816 73.0041 46.1412 75.9626 46.1412Z",
    fill: "#9CA4B5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.353 51.0091C77.353 52.3367 72.6913 53.4229 66.9664 53.4229C61.2005 53.4229 56.5388 52.3367 56.5388 51.0091H77.353Z",
    fill: "#9CA4B5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3791 62.5956C66.7211 62.5956 64.5947 60.4634 64.5947 57.8886V52.2562H74.2044V57.8886C74.2044 60.4634 72.0371 62.5956 69.3791 62.5956Z",
    fill: "#9CA4B5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M68.0704 99.7289C83.4502 99.7289 95.9181 97.3513 95.9181 94.4184C95.9181 91.4855 83.4502 89.1079 68.0704 89.1079C52.6905 89.1079 40.2227 91.4855 40.2227 94.4184C40.2227 97.3513 52.6905 99.7289 68.0704 99.7289Z",
    fill: "#A0A9BA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_25566_42450",
    x: 5.70605,
    y: 4.0426,
    width: 125.261,
    height: 118.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25566_42450"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25566_42450",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25566_42450",
    x1: 68.3103,
    y1: 13.3295,
    x2: 68.3103,
    y2: 89.9007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyorder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emptyorder.34881ef7.svg";
export { ForwardRef as ReactComponent };